export const APP_ENV = 'development';
export const APP_DEBUG = true;
export const APP_URL = 'http://localhost:3000';
export const API_URL = 'https://drivingcalendar.test';
export const CLIENT_ID = 2;
export const CLIENT_SECRET = 'cpwupGtc9WDv8Jw4kNDZnwLOoSBxJM8nHENZ68QT';
